<template>
  <div :class="`${currentConfig?.type} btn-upload-wrapper`">
    <slot name="beforeUploadButton" :config="config" :value="value" :uid="uid" />
    <template v-if="currentConfig?.type == 'dropdown'">
      <button data-toggle="dropdown" type="button" class="dropdown-toggle btn btn-outline-success w-100">Choose Images</button>
      <div tabindex="-1" role="menu" class="dropdown-menu w-100">
        <div class="d-flex flex-column">
          <div v-if="currentConfig.uploadFromFile" tabindex="0" class="btn btn-upload btn-outline-success cursor-pointer">
            <label :for="`upload-file-${uid}`" class="p-2 m-0 w-100 cursor-pointer">{{ `From file${currentConfig.multiple ? 's' : ''}` }}</label>
            <input :id="`upload-file-${uid}`" type="file" @change="changeFiles" :multiple="currentConfig.multiple" />
          </div>
          <div v-if="currentConfig.uploadFromFolder" tabindex="0" class="btn btn-upload btn-outline-success cursor-pointer">
            <label :for="`upload-folder-${uid}`" class="p-2 m-0 w-100 cursor-pointer">{{ `From folder${currentConfig.multiple ? 's' : ''}` }}</label>
            <input type="file" :id="`upload-folder-${uid}`" @change="changeFiles" webkitdirectory :multiple="currentConfig.multiple" />
          </div>
          <div v-if="currentConfig.uploadFromUrl" tabindex="0" class="btn btn-upload btn-outline-success cursor-pointer" @click="handleUploadFormUrl">
            <label class="p-2 m-0 w-100 cursor-pointer">{{ `From url${currentConfig.multiple ? 's' : ''}` }}</label>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="currentConfig?.type == 'list'">
      <div v-if="currentConfig.uploadFromFile" tabindex="0" class="btn btn-upload btn-outline-success cursor-pointer">
        <label :for="`upload-file-${uid}`" class="p-2 m-0 w-100 cursor-pointer">{{ `From file${currentConfig.multiple ? 's' : ''}` }}</label>
        <input :id="`upload-file-${uid}`" type="file" @change="changeFiles" :multiple="currentConfig.multiple" />
      </div>
      <div v-if="currentConfig.uploadFromFolder" tabindex="0" class="btn btn-upload btn-outline-success cursor-pointer">
        <label :for="`upload-folder-${uid}`" class="p-2 m-0 w-100 cursor-pointer">{{ `From folder${currentConfig.multiple ? 's' : ''}` }}</label>
        <input type="file" :id="`upload-folder-${uid}`" @change="changeFiles" webkitdirectory :multiple="currentConfig.multiple" />
      </div>
      <div v-if="currentConfig.uploadFromUrl" tabindex="0" class="btn btn-upload btn-outline-success cursor-pointer" @click="handleUploadFormUrl">
        <label class="p-2 m-0 w-100 cursor-pointer">{{ `From url${currentConfig.multiple ? 's' : ''}` }}</label>
      </div>
    </template>
    <slot name="afterUploadButton" :config="config" :value="value" :uid="uid" />
  </div>
</template>

<script>
import Md5 from 'crypto-js/md5'
export default {
  emits: ['changeValue', 'update:modelValue'],
  data() {
    return {
      uid: ''
    }
  },
  created() {
    this.uid = this.$util.randStr(10)
  },
  mounted() {
    this.handlePasteFormClipboard()
  },
  computed: {
    currentConfig() {
      return Object.assign(
        {
          multiple: false,
          uploadNow: true,
          uploadFromFile: true,
          uploadFromUrl: true,
          uploadFromFolder: false,
          group: true,
          type: 'dropdown'
        },
        this.config
      )
    },
    finalValues() {
      if (this.modelValue !== null) {
        return this.modelValue
      } else if (this.value !== null) {
        return this.value
      }
      return null
    }
  },
  methods: {
    handlePasteFormClipboard() {
      document.onpaste = (event) => {
        if (this.focus) {
          let hash
          let object = {}
          let files = []
          let index
          let items = (event.clipboardData || event.originalEvent.clipboardData).items
          for (index in items) {
            let item = items[index]
            if (item.kind === 'file') {
              let file = item.getAsFile()
              files.push(file)
            }
          }
          Object.values(files).forEach((file) => {
            if (file instanceof File || file instanceof Blob) {
              hash = Md5(this.getFileName(file.name)).toString()
              if (!object?.[hash]) {
                object[hash] = {
                  title: this.getFileName(file.name),
                  fileids: {},
                  files: []
                }
              }
              object[hash].files.push(file)
            }
          })
          this.prepareFiles(object)
        }
      }
    },
    handleUploadFormUrl() {
      this.$emitter.emit('SubModal', {
        name: 'upload-from-url',
        $el: false,
        data: this.row,
        callback: this.handleUploadFormUrlSubmit
      })
    },
    handleUploadFormUrlSubmit(e) {
      let promises = []

      Object.values(e).forEach((url) => {
        promises.push(
          new Promise((resolve) => {
            fetch(url)
              .then((res) => res.blob())
              .then((blob) => {
                if (blob.type.indexOf('image') != -1) {
                  resolve(
                    new File([blob], url.split('/').slice(-1)[0], {
                      type: blob.type,
                      lastModified: new Date().getTime()
                    })
                  )
                } else {
                  resolve(false)
                }
              })
          })
        )
      })
      Promise.all(promises).then((values) => {
        let hash
        let object = {}
        Object.values(values).forEach((file) => {
          if (file instanceof File || file instanceof Blob) {
            hash = Md5(this.getFileName(file.name)).toString()
            if (!object?.[hash]) {
              object[hash] = {
                title: this.getFileName(file.name),
                fileids: {},
                files: []
              }
            }
            object[hash].files.push(file)
          } else {
            this.$util.notify({
              status: 'warning',
              text: 'Some urls could not be downloaded'
            })
          }
        })
        this.prepareFiles(object)
      })
    },
    getFileName: function (str) {
      return str.replace(/\.[^/.]+$/, '').toLowerCase()
    },
    changeFiles(e) {
      e.preventDefault()
      let title
      let hash
      let object = {}
      Object.values(e.currentTarget.files).forEach((file) => {
        if (file.webkitRelativePath == '') {
          title = file.name.split('.').slice()[0]
        } else {
          title = file.webkitRelativePath.split('/').slice(-2)[0]
        }
        if (_.isString(title) && String(title).length > 0) {
          hash = Md5(this.getFileName(title)).toString()
          if (!object?.[hash]) {
            object[hash] = {
              title: this.getFileName(title),
              fileids: {},
              files: []
            }
          }
          object[hash].files.push(file)
        }
      })

      this.prepareFiles(object)
      e.currentTarget.value = ''
    },
    prepareFiles(object) {
      let values = this.$util.filter(!this.currentConfig.multiple ? [this.finalValues] : this.finalValues, ({ item }) => {
        return _.isString(item) || _.isArray(item?.files) || _.isArray(item?.urls)
      })

      Object.entries(object).forEach(([key, item]) => {
        let hash = key
        if (_.isUndefined(item.uploaded)) {
          item.uploaded = 0
        }
        if (_.isUndefined(item.status)) {
          item.status = 'pending'
        }

        if (!this.currentConfig.group) {
          let count = 0
          if (_.isObjectLike(item.files)) {
            Object.values(item.files).forEach((file) => {
              while (values?.[hash]) {
                count++
                hash = Md5(this.getFileName(`${item.title}-${count}`)).toString()
              }
              values[hash] = Object.assign({}, item)
              values[hash].files = [file]
            })
          }
          if (_.isObjectLike(item.urls)) {
            Object.values(item.urls).forEach((url) => {
              while (values?.[hash]) {
                count++
                hash = Md5(this.getFileName(`${item.title}-${count}`)).toString()
              }
              values[hash] = Object.assign({}, item)
              values[hash].urls = [url]
            })
          }
        } else {
          if (values?.[hash]) {
            if (_.isString(values[hash])) {
              values[hash] = {
                urls: [values[hash]]
              }
            }
            if (_.isUndefined(values[hash].files)) {
              values[hash].files = []
            }
            if (!_.isArray(values[hash].files)) {
              values[hash].files = Object.values(values[hash].files)
            }
            values[hash].files = values[hash].files.concat(object[hash].files)
          } else {
            values[hash] = item
          }
        }
      })

      this.emit(values)
      if (this.currentConfig.uploadNow) {
        this.uploadFiles(values)
      }
    },
    async uploadFiles(values) {
      let uploads = {}
      Object.entries(values).forEach(([key, item]) => {
        if (item.status == 'pending' && _.isArray(item.files) && (!_.isObjectLike(item.fileids) || item.files.length != Object.keys(item.fileids).length)) {
          uploads[key] = item
          uploads[key].status = 'doing'
        }
      })

      this.$util.storage.uploads(uploads, {
        process: (uploaded, item) => {
          values[item.id].uploaded = uploaded
          this.emit(values)
        },
        completed: (response) => {
          Object.entries(response.success).forEach(([id, item]) => {
            if (!_.isUndefined(values[id]) && _.isObjectLike(item.fileids)) {
              values[id].fileids = { ...item.fileids }
              values[item.id].uploaded = 100
              values[id].status = 'success'
            }
          })
          this.emit(values)
        },
        error: (response) => {
          Object.entries(response.error).forEach(([id, item]) => {
            if (!_.isUndefined(values[id]) && _.isObjectLike(item.fileids)) {
              values[id].fileids = { ...item.fileids }
              values[item.id].uploaded = 100
              values[id].status = 'error'
            }
          })

          this.emit(values)
        }
      })
    },
    emit(values) {
      if (!this.currentConfig.multiple) {
        const value = Object.assign({}, values[Object.keys(values)[0]])
        this.$emit('update:modelValue', value)
        return this.$emit('changeValue', value, {
          $el: this.$el
        })
      }
      values = Object.assign({}, values)
      this.$emit('update:modelValue', values)
      this.$emit('changeValue', values, {
        $el: this.$el
      })
    }
  },
  props: {
    focus: {
      type: Boolean,
      default() {
        return false
      }
    },
    value: {
      type: [String, Object, Array],
      default() {
        return null
      }
    },
    modelValue: {
      type: [String, Object, Array],
      default() {
        return null
      }
    },
    config: Object
  }
}
</script>

<style lang="scss">
.btn-upload-wrapper {
  .dropdown-menu {
    padding: 0;
  }
}
</style>
